// ===========================================
// Student View Context - Types & Context
// ===========================================
// Allows parents to toggle to a simplified student view
// for when their child is using the dashboard

import { createContext } from 'react';
import { StudentSummary } from '../api/user.api';

// State for student view mode
export interface StudentViewState {
  isStudentView: boolean;
  selectedStudent: StudentSummary | null;
}

// Context type with actions
export interface StudentViewContextType extends StudentViewState {
  enterStudentView: (student: StudentSummary) => void;
  exitStudentView: () => void;
  switchStudent: (student: StudentSummary) => void;
  updateStudentAvatar: (avatar: string | null) => void;
}

// Create context - exported for useStudentView hook
export const StudentViewContext = createContext<StudentViewContextType | undefined>(undefined);
